import  { hexToStr } from "."
import { db} from "../components/Authorization/firebase"
import {query, doc, getDoc, collection, getDocs, where, limit, orderBy, updateDoc, onSnapshot} from 'firebase/firestore'
import { PAYOUT_TYPE } from "./Enum"
import  { makeChannelPayout } from "./xrpl"
import { addPendingMusicRoyalties } from "./dbUtils/royaltyUtils"
import { getSwərlDetails } from "./swerlUtils"

export const makeMicropayment = async (url) => {
    let swərl = getSwərlDetails(url);
    let paymentChannel;
    let payout = 19;
    let userDoc;
    let userSubscription;
    let currencyRate = parseFloat(localStorage.getItem('USD'))
    return await getDocs(query(collection(db, "users",), where("uid", "==", swərl?.user), limit(1)))
      .then((collection) => {
        if (collection.empty) {
          return false;
        }
        userDoc = doc(db,`users/${collection.docs[0].id}`);
        userSubscription = collection.docs[0].data()?.subscription;
        return collection.docs[0].data()?.subscription;
      })
      .then(async (sub) => {
        if (sub > 0) {
          return await getDocs(query(collection(db,`subscriptions`)
            ,where("subscriber", "==", swərl?.user)
            ,orderBy("endDate", "desc")
            ,limit(1))).then((subscriptions) => {
              if (subscriptions.empty) {
                return false
              }
              let subscription = subscriptions.docs[0].data();
              let startDate = new Date(subscription.startDate)
              let endDate = new Date(subscription?.endDate);
              let currentDate = new Date();
              if (currentDate.getTime() < startDate.getTime() || currentDate.getTime() >= endDate.getTime()) {
                return false;
              } else {
                return {
                  subscription: sub,
                  ...subscription,
                };
              }
            })
            .then(async (subscription) => {
              if (userSubscription >= 31 && subscription) {
                switch (swərl?.type) {
                  case PAYOUT_TYPE.USER:
                    paymentChannel = await getDocs(query(collection(db,"users")
                      ,where("uid", "==", swərl?.typeId)
                      ,limit(1)))
                      .then((collection) => {
                        if (collection.empty) {
                          return false;
                        }
                        return collection?.docs[0]?.data()?.paymentChannel;
                      })
                      .catch((err) => {
                        console.error(err);
                        return false;
                      });
                    break;
                  case PAYOUT_TYPE.ARTIST:
                    paymentChannel = await getDoc(doc(db,`artists/${swərl?.typeId}`))
                      .then((artist) => {
                        if (artist?.exists) {
                          return artist.data()?.paymentChannel;
                        }
                        return false;
                      })
                      .catch((err) => {
                        console.error(err);
                        return false;
                      });
                    break;
                  case PAYOUT_TYPE.PODCASTER:
                    paymentChannel = await getDoc(doc(db,`podcasters/${swərl?.typeId}`))
                      .then((podcaster) => {
                        if (podcaster?.exists) {
                          return podcaster.data()?.paymentChannel;
                        }
                        return false;
                      })
                      .catch((err) => {
                        console.error(err);
                        return false;
                      });
                    break;
                  case PAYOUT_TYPE.RECORD_LABEL:
                    paymentChannel = await getDoc(doc(db,`recordLabels/${swərl?.typeId}`))
                      .then((label) => {
                        if (label?.exists) {
                          return label.data()?.paymentChannel;
                        }
                        return false;
                      })
                      .catch((err) => {
                        console.error(err);
                        return false;
                      });
                    break;
                      
                  default:
                    break;
                }
                try {
                  if(parseFloat((userSubscription / 1000000) * currencyRate).toFixed(6) >= 5){
                    for (let i = 0; i < 3; i++) {
                        onSnapshot(userDoc,
                        async (docSnapshot) => {
                          userSubscription = docSnapshot.data()?.subscription;
                        },
                        (err) => {
                          console.error(`Encountered error: ${err}`);
                          return false
                        }
                      );
                     payout = await getPayoutRate(parseFloat((userSubscription / 1000000) * currencyRate).toFixed(6))
                        await processPayout(payout, swərl, paymentChannel?.channel, userDoc)
                    }
                  }else{
                    
                      await onSnapshot(userDoc,
                        async (docSnapshot) => {
                          userSubscription = docSnapshot.data()?.subscription;
                        },
                        (err) => {
                          console.error(`Encountered error: ${err}`);
                          return false
                        }
                      );
                     payout = await getPayoutRate(parseFloat((userSubscription / 1000000) * currencyRate).toFixed(6))
                        await processPayout(parseInt(payout), swərl, paymentChannel?.channel, userDoc)
                  }
                  return true
                } catch (err) {
                  //console.error(err);
                  return false
                }
              } else {
                return false
              }
            })
            .catch((err) => {
              //console.error(err);
              return false
            });
        } else {
          return false
        }
      })
      .catch((err) => {
        console.error(err);
        return false
      });
  };

    const getPayoutRate = async (balance) => {
    const SECONDS_PER_HOUR = 3600;
  const DROPS_PER_XRP = 1000000;
    let currencyRate = parseFloat(localStorage.getItem('USD'))
  // Validate the inputs to prevent division by zero or other errors.
      if (typeof parseInt(balance) !== 'number' || typeof parseInt(currencyRate) !== 'number' || currencyRate < 0 || balance <= 0) {
    console.error("Invalid input: userBalanceUSD and xrpPriceUSD must be positive numbers.", currencyRate, balance);
    return 0;
  }
  //console.log(balance, currencyRate)
  // Determine the hourly payout rate in USD based on the user's current balance.
  let payoutRateUSD;

  // Tier 4: Higher rate for high-volume users (balance >= $5)
  if (balance >= 10.00) {
    payoutRateUSD = 0.40;
  }

  else if (balance >= 5.00 && balance < 10.00) {
    payoutRateUSD = 0.35;
  }
  // Tier 3: Medium-low rate (balance >= $1.50, up to $2.00)
  else if (balance >= 1.50 && balance < 2.50) {
    payoutRateUSD = 0.20;
  }
  else if (balance > 0 && balance < 1.00) {
    payoutRateUSD = 0.05;
  }
  // Tier 2: Medium rate (balance >= $1.00, up to $1.50)
  else if (balance >= 1.00 && balance < 1.50) {
    payoutRateUSD = 0.10;
  }
  // Tier 1: Initial rate (balance < $1.00)
  else {
    payoutRateUSD = 0.25;
  }


  // Calculate the per-second payout in USD.
  const payoutPerSecondUSD = payoutRateUSD / SECONDS_PER_HOUR;

  // Convert the USD per-second payout to XRP per second.
  const payoutPerSecondXRP = payoutPerSecondUSD / currencyRate;
  // Convert the XRP per-second payout to drops per second.
  const payoutPerSecondDrops = payoutPerSecondXRP * DROPS_PER_XRP;
  return parseFloat(payoutPerSecondDrops).toFixed(0);
}

  export const processPayout = async(payout, swərl, paymentChannel, userDoc) => {
    let payment
    if(payout > 0){
    if(swərl.type === PAYOUT_TYPE.ROYALTY_SHARE){
      payment = await addPendingMusicRoyalties(swərl.typeId, payout.toString())
    }else{
      /*  if (swərl.paymentChannel?.channel) {
      payment = await makeChannelPayout({
        paymentChannel: paymentChannel,
        amount: payout.toString(),
        title: swərl.title
      });
      if(!payment){
        payment = await makePendingFundsPayment(
          swərl.type,
          swərl.typeId,
          payout
        );
      }
    } else {
      payment = await makePendingFundsPayment(
        swərl.type,
        swərl.typeId,
        payout
      );
    } */
    payment = await makePendingFundsPayment(
      swərl.type,
      swərl.typeId,
      payout
    );
    }
    if (payment) {
     
     return await getDoc(userDoc).then(
        async (docSnapshot) => {
          if(parseInt(docSnapshot.data()?.subscription) > 0){
           let fee = 12
            if(payout >= 19 && payout < 190 ){
              fee = 9
            }
            if(payout >= 6 && payout < 19){
              fee = 6
            }
            
            await updateDoc(userDoc,{
              subscription: parseInt(parseInt(docSnapshot.data()?.subscription) - parseInt(payout + fee)),
            });
            return true
          }
          return true
        }).catch(
        (err) => {
          console.error(`Encountered error: ${err}`);
          return false
        }
      );
      
      
    }
  }else{
      return
    }
  }

  export const makePendingFundsPayment = async (type, id, payout) => {
    let payment;
    switch (type) {
      case PAYOUT_TYPE.USER:
        return await getDocs(query(collection(db,"users")
          ,where("uid", "==", id)
          ,limit(1)))
          .then(async (collection) => {
            if (collection.empty) {
              return false;
            }
            let pendingFunds = 0
            await onSnapshot(doc(db,`users/${collection?.docs[0]?.id}`),
              async (docSnapshot) => {
                  pendingFunds = parseInt(docSnapshot.data()?.pendingFunds) > 0 ? parseInt(docSnapshot.data()?.pendingFunds) : 0;
                  return pendingFunds
              },
              (err) => {
                console.error(`Encountered error: ${err}`);
                return false
              }
            );
            pendingFunds = parseInt(pendingFunds) + payout
              payment = await updateDoc(doc(db,`users/${collection?.docs[0]?.id}`),{ pendingFunds: pendingFunds })
                .then(() => {
                  return true;
                })
                .catch((err) => {
                  console.error(err);
                  return false;
                });
            return payment;
          })
          .catch((err) => {
            console.error(`Encountered error: ${err}`);

            return false;
          });
     
      case PAYOUT_TYPE.ARTIST:
        return await getDoc(doc(db,`artists/${id}`))
          .then(async (artist) => {
            if (artist?.exists) {
              let pendingFunds = artist.data()?.pendingFunds ? artist.data()?.pendingFunds : 0;
                await onSnapshot(doc(db,`artists/${id}`),
                async (docSnapshot) => {
                  pendingFunds = parseInt(docSnapshot.data()?.pendingFunds) > 0 ? parseInt(docSnapshot.data()?.pendingFunds) : 0;
                  return pendingFunds
                },
                (err) => {
                  console.error(`Encountered error: ${err}`);
                  return false
                }
              );
              pendingFunds = parseInt(pendingFunds) + parseInt(payout)
                payment = await updateDoc(doc(db,`artists/${id}`),{ pendingFunds: pendingFunds })
                  .then(() => {
                    return true;
                  })
                  .catch((err) => {
                    //console.error(`Encountered error: ${err}`);
                    return false;
                  });
              return payment;
            }
            return false;
          })
          .catch((err) => {
            console.error(err);
            payment = false;
            return false;
          });
        
      case PAYOUT_TYPE.PODCASTER:
        return await getDoc(doc(db,`podcasters/${id}`))
          .then(async (podcaster) => {
            if (podcaster?.exists) {
                let pendingFunds = 0
                await onSnapshot(doc(db,`podcasters/${id}`),
                async (docSnapshot) => {
                  pendingFunds = parseInt(docSnapshot.data()?.pendingFunds) > 0 ? parseInt(docSnapshot.data()?.pendingFunds) : 0;
                  return pendingFunds
                },
                (err) => {
                  console.error(err);                  
                  return false
                }
              );
              pendingFunds = parseInt(pendingFunds) + parseInt(payout)
                payment = await updateDoc(doc(db,`podcasters/${id}`),{ pendingFunds: pendingFunds })
                  .then(() => {
                    return true;
                  })
                  .catch((err) => {
                    console.error(err);
                    return false;
                  });

              return payment;
            }
            payment = false;
            return false;
          })
          .catch((err) => {
            console.error(err);
            payment = false;
  
            return false;
          });
        
      case PAYOUT_TYPE.RECORD_LABEL:
        return await getDoc(doc(db,`recordLabels/${id}`))
          .then(async (label) => {
            if (label?.exists) {
              let pendingFunds = 0
              await onSnapshot(doc(db,`recordLabels/${id}`),
              async (docSnapshot) => {
                  pendingFunds = parseInt(docSnapshot.data()?.pendingFunds) > 0 ? parseInt(docSnapshot.data()?.pendingFunds) : 0;
                  return pendingFunds
              },
              (err) => {
                console.error(`Encountered error: ${err}`);
                return false
              }
            );
            pendingFunds = parseInt(pendingFunds) + parseInt(payout)
                payment = await updateDoc(doc(db,`recordLabels/${id}`),{ pendingFunds: pendingFunds })
                  .then(() => {
                    return true;
                  })
                  .catch((err) => {
                    console.error(err);
                    return false;
                  });
              return payment;
            }
            return false;
          })
          .catch((err) => {
            console.error(err);
            payment = false;
            return false;
          });
       
  
      default:
        payment = false;
  
        return false;
        break;
    }
  };


  export const addToPendingFunds = (type, id, payout) => {

  }

